import React, { useEffect, useRef, createContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setStatus, batchUpdateStatus } from 'src/redux/slices/wf';

const LocalSyncContext = createContext();
const channel = new BroadcastChannel('wf_channel');

export const LSProvider = ({ children }) => {
  const dispatch = useDispatch();
  const channelRef = useRef(null);
  const { frontEnd } = useSelector(({ bizMeta }) => bizMeta);
  const isLocalSyncAllowed = frontEnd?.socket?.local_sync ?? false;
  //functions for listeners
  const LISTENERS = {
    wf_change: data => {
      dispatch(setStatus(data));
    },
    batch_wf_change: data => {
      dispatch(batchUpdateStatus(data));
    }
  };

  useEffect(() => {
    channelRef.current = channel;

    channel.onmessage = event => {
      const { type, ...data } = event.data;
      const handler = LISTENERS[type];

      if (handler && isLocalSyncAllowed) {
        handler(data);
      }
    };

    return () => {
      channel.close();
    };
  }, [dispatch, isLocalSyncAllowed]);
  return null;
};

export default LocalSyncContext;
